import { render, staticRenderFns } from "./BullProducedTable.vue?vue&type=template&id=4fa2ff4e&scoped=true&"
import script from "./BullProducedTable.vue?vue&type=script&lang=js&"
export * from "./BullProducedTable.vue?vue&type=script&lang=js&"
import style0 from "./BullProducedTable.vue?vue&type=style&index=0&id=4fa2ff4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa2ff4e",
  null
  
)

export default component.exports